import type { BlockProps } from './block.types';
import clsx from 'clsx';
import { cn } from '@/utils/helper';
import v1 from './block-v1.module.css';
import v2 from './block-v2.module.css';

export default function Block(props: BlockProps) {
  return (
    <div
      className={clsx(cn(v1.Block, v2.Block), {
        [cn(v1.BlockImageLeft, v2.BlockImageLeft)]: props.imagePosition === 'left',
        [cn(v1.BlockImageRight, v2.BlockImageRight)]: props.imagePosition === 'right',
      })}
    >
      <div className={cn(v1.Image, v2.Image)}>{props.image}</div>
      <div className={cn(v1.Main, v2.Main)}>
        <div className={cn(v1.Title, v2.Title)}>{props.title}</div>
        <div>{props.text}</div>
      </div>
      <div className={cn(v1.Button, v2.Button)}>{props.button}</div>
    </div>
  );
}
